import Api from '../../../shared/Api';
import { IStylingFirm, IProduct } from '../Entities';

class StylingFirmsApi {
    static getStylingFirmProducts() {
        return new Api().get('/views/stylingfirms/products');
    }

    static getStylingFirms(): any {
        return new Api().get('/views/stylingfirms');
    }

    static saveStylingFirm(stylingFirm: IStylingFirm): any {
        return new Api().post('/views/stylingfirms', {
            name: stylingFirm.name,
            products: stylingFirm.products.map((product: IProduct) => {
                return product.id;
            })
        });
    }

    static getStylingFirm(id: number): any {
        return new Api().get(`/views/stylingfirms/${id}/edit`);
    }

    static updateStylingFirm(stylingFirm: IStylingFirm): any {
        return new Api().put(`/views/stylingfirms/${stylingFirm.id}`, {
            id: stylingFirm.id,
            name: stylingFirm.name,
            products: stylingFirm.products.map((product: IProduct) => {
                return product.id;
            })
        });
    }

    static deleteStylingFirm(stylingFirm: IStylingFirm): any {
        return new Api().delete(`/views/stylingfirms/${stylingFirm.id}`);
    }
}

export default StylingFirmsApi;
